import { APICallV4 } from 'reactApp/api/APICall';
import { Method } from 'axios';

export class DigestAPICall extends APICallV4 {
    _method = 'private/digest';
    _type: Method = 'get';
}
